<template>
  <div
    class="menu-link"
    :class="link.class"
  >
    <a v-bind="linkAttrs(link)" @click="$emit('click', link)">
      <div class="head-flex align-center">
        <span v-html="link.name" />
        <i
          v-if="link.links && link.links.length"
          class="icon-droplist"
          v-html="require('@/assets/img/icon-droplist-small.svg')"
        />
      </div>
    </a>
    <div class="menu-child">
      <a
        v-for="child in link.links"
        :key="child.name"
        v-bind="linkAttrs(child)"
        v-html="child.name"
        @click="$emit('click', link)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadLink',
  props: {
    link: Object,
    headerLinkTarget: String
  },
  methods: {
    linkAttrs (link) {
      const _link = {
        target: this.headerLinkTarget,
        'data-head-link': link.name,
        ...link,
        class: 'link-group' + (link.class ? ` ${link.class}` : ''),
      }

      if (link.url) {
        _link.href = link.url
      }

      return _link
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-child {
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  min-width: 100%;
  padding-top: 19px;
  transform: scaleY(0);
  transform-origin: top;
  animation: ani 0.25s forwards;
  filter: drop-shadow(0px 15px 20px #E5ECEB);
  @keyframes ani {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }

  a {
    font-weight: 500;
    font-size: 16px;
    color: #252525;
    padding: 12px 24px;
    display: block;
    background-color: #fff;
    &:hover {
      color: #00AFA1;
      background-color: #E9FAF8;
    }
    &:first-child {
      border-radius: 12px 12px 0 0;
    }
    &:last-child {
      border-radius: 0 0 12px 12px;
    }
    &:only-child {
      border-radius: 12px;
    }
  }
}
.menu-link:hover .menu-child {
  display: block;
}

.head-flex {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: nowrap;
}

.head-flex-item {
  flex: 1;
}

.head-flex-auto {
  flex: 0 0 auto;
}

.menu-link {
  position: relative;
  &:hover .icon-droplist {
    transform: rotate(-180deg);
  }
}

.icon-droplist {
  position: relative;
  left: 3px;
  display: flex;
  align-items: center;
  transition: all .2s ease;

  ::v-deep svg {
    transition: all .2s ease;
    width: 16px !important;
    height: 16px !important;
  }
}
</style>
